"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Apple(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M16.47 6.514c1.425 0 3.353.913 4.44 2.957a3.993 3.993 0 0 0 .09 7.106C19.795 19.536 17.395 22 15.853 22h-.029c-1.268 0-1.712-.823-3.45-.832-1.74.009-2.184.832-3.453.832h-.029C6.766 22 3 17.325 3 13.112 3 8.48 6.181 6.515 8.275 6.514c1.54 0 2.825 1.04 4.098 1.04 1.272 0 2.558-1.04 4.097-1.04zm0 2c-.43 0-.962.205-1.52.422-.749.29-1.597.619-2.577.619s-1.827-.33-2.575-.62c-.56-.217-1.09-.421-1.523-.421C7.207 8.514 5 9.639 5 13.112c0 3.326 2.941 6.645 3.931 6.886.166-.005.282-.046.641-.201.577-.248 1.448-.622 2.79-.63 1.361.008 2.234.382 2.811.63.375.16.485.2.637.203.451-.114 1.677-1.135 2.668-2.82a5.966 5.966 0 0 1-1.69-4.18c0-1.413.493-2.75 1.36-3.802-.609-.488-1.26-.684-1.678-.684zM16 2c-1.135 0-2.232.48-2.957 1.268-.657.717-1.055 1.989-1.055 3.014 1.172 0 2.424-.601 3.12-1.403.647-.751.892-1.67.892-2.88", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Apple;
